export const LINE_ITEM_TEST_ID = {
    root: 'cart-item-wrapper',
    remove: 'cart-item-remove',
    modifier: 'cart-item-modifiers',
    item: 'cart-item',
    note: 'cart-item-note',
    discountName: 'cart-item-discount-name',
    discountAmount: 'cart-item-discount-amount'
  };
